var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0912 55.0964C71.4017 55.0964 76.8674 51.4833 79.5355 46.2099C79.6944 45.9004 79.7738 45.5575 79.7864 45.2146H50.3918C50.4044 45.5575 50.4838 45.9004 50.6428 46.2099C53.3108 51.4791 58.7807 55.0964 65.0912 55.0964Z",
    fill: "url(#paint0_linear_52_318)",
    fillOpacity: 0.1,
    stroke: "url(#paint1_linear_52_318)",
    strokeOpacity: 0.1,
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9921 72.9448L14.6785 80.2799H66.3123L57.9987 72.9448H22.9921Z",
    fill: "url(#paint2_linear_52_318)",
    fillOpacity: 0.1,
    stroke: "url(#paint3_linear_52_318)",
    strokeOpacity: 0.1,
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4933 12.5122C43.6158 12.5122 46.1472 9.98084 46.1472 6.85826C46.1472 3.73569 43.6158 1.20435 40.4933 1.20435C37.3707 1.20435 34.8394 3.73569 34.8394 6.85826C34.8394 9.98084 37.3707 12.5122 40.4933 12.5122Z",
    fill: "url(#paint4_linear_52_318)",
    fillOpacity: 0.1,
    stroke: "url(#paint5_linear_52_318)",
    strokeOpacity: 0.1,
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9037 55.0964C22.2142 55.0964 27.6799 51.4833 30.348 46.2099C30.5069 45.9004 30.5863 45.5575 30.5989 45.2146H1.20435C1.21689 45.5575 1.29635 45.9004 1.45526 46.2099C4.12331 51.4791 9.59322 55.0964 15.9037 55.0964Z",
    fill: "url(#paint6_linear_52_318)",
    fillOpacity: 0.1,
    stroke: "url(#paint7_linear_52_318)",
    strokeOpacity: 0.1,
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4932 12.5122V72.9447",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1514 6.85815H73.4089",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5591 44.1818C50.3165 44.8425 50.3249 45.5869 50.6385 46.21C53.3066 51.4792 58.7765 55.0965 65.087 55.0965C71.3974 55.0965 76.8632 51.4834 79.5312 46.21C79.849 45.5827 79.8574 44.8425 79.6149 44.1818L66.3875 13.8296C65.8982 12.6838 64.2757 12.6838 63.7906 13.8296L50.5632 44.1818H50.5591Z",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3916 45.2146H73.6722",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6782 80.2798H66.3121",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9919 72.9448H57.9986",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.37156 44.1818C1.12901 44.8425 1.13738 45.5869 1.45102 46.21C4.11907 51.4792 9.58898 55.0965 15.8995 55.0965C22.2099 55.0965 27.6757 51.4834 30.3437 46.21C30.6615 45.5827 30.6699 44.8425 30.4274 44.1818L17.2 13.8296C16.7107 12.6838 15.0882 12.6838 14.6031 13.8296L1.37156 44.1818Z",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20435 45.2146H24.4849",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8392 6.85815H7.57739",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4932 12.5122V72.9447",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1514 6.85815H73.4089",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5591 44.1818C50.3165 44.8425 50.3249 45.5869 50.6385 46.21C53.3066 51.4792 58.7765 55.0965 65.087 55.0965C71.3974 55.0965 76.8632 51.4834 79.5312 46.21C79.849 45.5827 79.8574 44.8425 79.6149 44.1818L66.3875 13.8296C65.8982 12.6838 64.2757 12.6838 63.7906 13.8296L50.5632 44.1818H50.5591Z",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3916 45.2146H73.6722",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6782 80.2798H66.3121",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9919 72.9448H57.9986",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.37156 44.1818C1.12901 44.8425 1.13738 45.5869 1.45102 46.21C4.11907 51.4792 9.58898 55.0965 15.8995 55.0965C22.2099 55.0965 27.6757 51.4834 30.3437 46.21C30.6615 45.5827 30.6699 44.8425 30.4274 44.1818L17.2 13.8296C16.7107 12.6838 15.0882 12.6838 14.6031 13.8296L1.37156 44.1818Z",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20435 45.2146H24.4849",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8392 6.85815H7.57739",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4931 1.20435C37.3692 1.20435 34.835 3.73439 34.835 6.86245C34.835 9.9905 37.365 12.5164 40.4931 12.5164C43.6211 12.5164 46.1512 9.98632 46.1512 6.86245",
    stroke: "#0478FE",
    strokeWidth: 2.40459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_318",
    x1: 65.0891,
    y1: 45.2146,
    x2: 65.0891,
    y2: 55.0964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_318",
    x1: 65.0891,
    y1: 45.2146,
    x2: 65.0891,
    y2: 55.0964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_52_318",
    x1: 40.4954,
    y1: 72.9448,
    x2: 40.4954,
    y2: 80.2799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_52_318",
    x1: 40.4954,
    y1: 72.9448,
    x2: 40.4954,
    y2: 80.2799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_52_318",
    x1: 40.4933,
    y1: 1.20435,
    x2: 40.4933,
    y2: 12.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_52_318",
    x1: 40.4933,
    y1: 1.20435,
    x2: 40.4933,
    y2: 12.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_52_318",
    x1: 15.9016,
    y1: 45.2146,
    x2: 15.9016,
    y2: 55.0964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_52_318",
    x1: 15.9016,
    y1: 45.2146,
    x2: 15.9016,
    y2: 55.0964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0478FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0478FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.9907,
    height: 81.48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.2fb344f3574ee97a5f85950369f36d1e.svg";
export { ForwardRef as ReactComponent };